/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTable3Regular: {
  name: 'table-3-regular';
  data: string;
} = {
  name: 'table-3-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.477 4.073c-.489.128-.931.47-1.212.941-.279.465-.265.095-.263 7.014.002 5.758.008 6.252.071 6.495.18.689.787 1.272 1.476 1.418.407.086 16.495.086 16.902 0 .371-.078.641-.232.95-.54.308-.309.462-.579.54-.95.086-.405.086-12.497 0-12.902-.146-.689-.729-1.296-1.418-1.476-.244-.064-.844-.068-8.523-.068s-8.279.004-8.523.068M8 7.5V9H4V6h4zm6 0V9h-4V6h4zm6 0V9h-4V6h4zM8 12v1H4v-2h4zm6 0v1h-4v-2h4zm6 0v1h-4v-2h4zM8 16.5V18H4v-3h4zm6 0V18h-4v-3h4zm6 0V18h-4v-3h4z"/></svg>`
};
